import { Box, Container, Stack, Typography, styled } from '@mui/material';
import React from 'react';

import { MessageChatCircleIcon } from '@/assets/icons/MessageChatCircleIcon';

const SectionWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  backgroundColor: theme.palette.common.white,
}));

const MissionLabel = styled(Typography)(({ theme }) => ({
  fontSize: '1.125rem',
  fontWeight: 600,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(1),
}));

const MissionHeading = styled(Typography)(({ theme }) => ({
  fontFamily: '"Nohemi", sans-serif !important',
  fontWeight: 600,
  fontSize: '1.875rem',
  color: '#181D27',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    fontSize: '2.25rem',
  },
}));

const MissionText = styled(Typography)(({ theme }) => ({
  fontSize: '1.125rem',
  lineHeight: 1.6,
  color: '#535862',
  marginBottom: theme.spacing(2),
}));

const IconContainer = styled(Box)(({ theme }) => ({
  width: '56px',
  height: '56px',
  borderRadius: '28px',
  backgroundColor: '#FFF4F3',
  border: '8px solid #FFE7E3',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.main,
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 1,
  },
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}));

const OurMissionSection: React.FC = () => (
  <SectionWrapper>
    <Container maxWidth="lg">
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
        <Box sx={{ flex: 1, p: { xs: 3, md: 6 } }}>
          <IconContainer>
            <MessageChatCircleIcon />
          </IconContainer>

          <MissionLabel>Our Mission</MissionLabel>

          <MissionHeading>Property Management, Reinvented by AI</MissionHeading>

          <MissionText>
            We're on a mission to transform the way property management works — not with more
            software, but with real intelligence.
          </MissionText>

          <MissionText>
            By harnessing the power of cutting-edge AI, we automate the repetitive, streamline the
            chaotic, and surface the insights that matter. Our platform is built to learn from you,
            adapt to your workflow, and scale with your growth — whether you're managing one unit or
            hundreds.
          </MissionText>

          <MissionText>
            The result? More time. Less stress. Happier tenants. Smarter decisions. Because managing
            properties shouldn't mean managing burnout.
          </MissionText>
        </Box>

        <Box sx={{ flex: 1 }}>
          <ImageContainer>
            <img
              src="/assets/images/aboutus/mission-image.jpg"
              alt="Property Management Reinvented"
            />
          </ImageContainer>
        </Box>
      </Stack>
    </Container>
  </SectionWrapper>
);

export default OurMissionSection;
